import api from './api';

export interface ContractType {
  id: number;
  valor: string;
  descricao: string;
}

export interface Formacao {
  id: number;
  valor: string;
  descricao: string;
}

export class DomainService {
  /**
   * Busca os tipos de contrato disponíveis
   * @returns Promise com lista de tipos de contrato
   */
  static async getContractTypes(): Promise<ContractType[]> {
    try {
      const response = await api.get<ContractType[]>('/domain/contract-type');
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Busca as formações acadêmicas disponíveis
   * @returns Promise com lista de formações
   */
  static async getFormacoes(): Promise<Formacao[]> {
    try {
      const response = await api.get<Formacao[]>('/domain/academic-formation');
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Busca os tipos de exame disponíveis
   * @returns Promise com lista de tipos de exame
   */
  static async getExamTypes(): Promise<Array<{ id: number; nome: string }>> {
    try {
      const response = await api.get<Array<{ id: number; nome: string }>>('/domain/exam-types');
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Trata erros da API
   */
  private static handleApiError(error: any): Error {
    if (error.response?.data) {
      const apiError = new Error(error.response.data.message || 'Erro na requisição');
      (apiError as any).statusCode = error.response.status;
      (apiError as any).error = error.response.data.error;
      return apiError;
    }

    return new Error('Erro de conexão com o servidor');
  }
}

export const domainService = DomainService;
